






























































































































































































































































































































































import {
	AccountTypeEnum,
	BillingModel,
	PatchBatchDocument,
	PaymentModel,
	QueryOperator,
	SortOrder,
	TenantUserModel,
	TransactionEmailType,
	WorkTaskStatementModel
} from '@/libs/Api';
import ExportDialog from '@/libs/common/components-smart/ExportDialog.vue';
import {useObjectKey} from '@/libs/common/functions/use-object-key';
import {createAggregationQueryPayload} from '@/libs/core/+state/models/aggregation-query-payload';
import {CrudAction, CrudReponse} from '@/libs/core/+state/models/crud-action';
import {CrudDataStats} from '@/libs/core/+state/models/crud-data-stats';
import {CrudGetter} from '@/libs/core/+state/models/crud-getter';
import {createCrudQueryPayload} from '@/libs/core/+state/models/crud-query-payload';
import {CrudQueryPredicate} from '@/libs/core/+state/models/crud-query-predicate';
import {workTaskStatementsStore} from '@/libs/work-task-statements/+state/store';
import Page from '@/Page.vue';
import moment from 'moment';
import {Component, Prop, Ref, Watch} from 'vue-property-decorator';
import StatementDetailDialog from '@/libs/statements/components/StatementDetailDialog.vue';
import {authStore} from '@/libs/auth/+store/store';
import {AuthGetter} from '@/libs/auth/models/auth-state';
import {billingsStore} from '../+state/store';
import {cloneDeep} from "lodash";
import {paymentsStore} from "@/libs/payments/+state/store";
import {Guid} from "@/libs/common/functions/guid";
import ApiService from "@/libs/core/api-service";
import {BillingActionEnum} from "@/libs/billings/model/BillingActionEnum";

@Component({
	computed: {
		BillingActionEnum() {
			return BillingActionEnum
		}
	},
    components: {
        StatementDetailDialog
    }
})
export default class Billing extends Page {

    filterStart: string | null = "";
    filterEnd: string | null = "";
    filterUser: string | null = "";
    filterType: string | null = "";
    loading = true;
    loadingStatements = false;
    pageInitialization = true;
    mobileFiltersShow = false;
    deleteDialog = false;
    deleting = false;
    pageIndex = 1;
    pageSize = 25;
    sortBy = [ "workTask.time" ];
    sortDesc = [ false ];
	isSendingBillingToClient = false;
	isSendingReceiptToClient = false;
	unlocking = false;
	isLocking = false;
	paymentDialog = false;
	deletePaymentDialog = false;
	activePayment: PaymentModel | null = null;
	deletingPayment = false;
	newId = Guid.EmptyGuid();
	basicRules = [
		(v: any) => !!v || this.translate('validation.thisFieldIsRequired')
	];
	greaterThenZeroRules = [
		(v: any) => (v != null && Number(v) > 0) || this.translate('validation.thisFieldIsRequired')
	];

    get headers() {
        return [
            { text: this.$i18n.t("statements.columnDate"), value: "workTask.time", align: "left", width: "5%" },
            { text: this.$i18n.t("statements.columnSocialWorker"), value: "user.lastName", align: "left", width: "8%" },
            { text: this.$i18n.t("statements.columnTask"), value: "workTask.catalogueItem.name", align: "left" },
            { text: this.$i18n.t("statements.columnPricePerUnit"), value: "workTask.unitPrice", align: "left", width: "14%" },
            { text: this.$i18n.t("statements.columnAmount"), value: "amount", align: "left", width: "10%" },
            //{ text: "Návštěva", value: "visitNumber", align: "left", width: "5%" },
            { text: this.$i18n.t("statements.columnPrice"), value: "price", align: "left", width: "10%" },
            { text: "", value: "id", align: "left", width: "5%" },
        ];
    }

    get paymentHeaders() {
        return [
            { text: "Datum platby", value: "paidOn", align: "left", width: "30%" },
            { text: "Způsob platby", value: "paymentMethod.name", align: "left", width: "30%" },
						{ text: "Zaplacená částka", value: "paidAmount", align: "left", width: "40%" },
						{ text: "", value: "id", align: "left", width: "5%" },
        ];
    }

    @Prop() tenantId!: string;
    @Prop() billingId!: string;

    @Ref() exportDialog!: ExportDialog;
    @Ref() dialog!: StatementDetailDialog;

    @Watch("filterStart")
    @Watch("filterEnd")
    @Watch("filterUser")
    filtersChanged (v: string, p: string) {
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.loadStatements();
        });
    }

    @Watch("pageIndex")
    @Watch("pageSize")
    paginationChanged () {
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.loadStatements();
        });
    }

    @Watch("pageSize")
    pageSizeChanged () {
        this.pageIndex = 1;
    }

    get workTaskStatements () {
        return [...workTaskStatementsStore.useGetter(CrudGetter.Data)];
    }

    get payments () {
        return [...paymentsStore.useGetter(CrudGetter.Data)];
    }

    get loadingPayments (): boolean {
        return paymentsStore.useGetter(CrudGetter.Pending);
    }

    get savingPayment (): boolean {
        return paymentsStore.useGetter(CrudGetter.Saving);
    }

    get totalRows (): number {
        return ({...workTaskStatementsStore.useGetter(CrudGetter.DataStats)} as CrudDataStats)?.rowCount;
    }

    get moneySum () {
        return workTaskStatementsStore.useGetter(CrudGetter.Sum);
    }

    get exporting(): boolean {
        return workTaskStatementsStore.useGetter(CrudGetter.Downloading);
    }

    get isAdmin (): boolean {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        return tenantUser.accountType == AccountTypeEnum.Admin;
    }

    get billing () {
        return billingsStore.useGetter(CrudGetter.Detail, this.billingId);
    }

    @Watch("sortBy")
    @Watch("sortDesc")
    sortChanged () {
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.loadStatements();
        });
    }

    mounted () {
        this.load();
    }

	load() {
		this.loading = true;
		Promise.all([
			this.loadBilling(),
			this.loadStatements(),
			this.loadPayments(),
			this.loadSum()
		]).then(() => {
			this.loading = false;
		}).catch((e) => {
			console.error(e);
			this.loading = false;
		});
	}

    clearFilters () {
        this.filterStart = this.billing.fromDate;
        this.filterEnd = this.billing.toDate;
        this.filterUser = null;
        this.filterType = null;
    }

    loadBilling (): Promise<BillingModel> {
        return new Promise<BillingModel>((resolve, reject) => {
            billingsStore.dispatch(CrudAction.Get, { id: this.billingId, key: this.billingId });
            this.subscribe(billingsStore, CrudReponse.Get, this.billingId).then((e: BillingModel) => {
                resolve(e);
								this.filterStart = this.billing.fromDate;
								this.filterEnd = this.billing.toDate;
            }).catch((e) => {
                console.error(e);
                reject(e);
            })
        });
    }

    loadStatements (): Promise<any> {
        this.loadingStatements = true;
        return new Promise<any>((resolve, reject) => {
            workTaskStatementsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<WorkTaskStatementModel>([
							{ field: "workTask.time", index: 1, order: SortOrder.Asc },
							{ field: "workTask.catalogueItem.name", index: 2, order: SortOrder.Asc }
						], this.getFilters(), undefined));
            this.subscribe(workTaskStatementsStore, CrudReponse.GetAll).then(() => {
                resolve("ok");
                this.pageInitialization = false;
                this.loadingStatements = false;
            }).catch((e) => {
                this.loadingStatements = false;
                console.error(e);
                reject(e);
            });
        })
    }

    loadSum () {
        return new Promise<any>((resolve, reject) => {
            workTaskStatementsStore.dispatch(CrudAction.GetSum, createAggregationQueryPayload(this.getFilters(), useObjectKey<WorkTaskStatementModel>("price")))
            this.subscribe(workTaskStatementsStore, CrudReponse.GetSum).then(() => {
                resolve("ok");
            }).catch((e) => {
                console.error(e);
                reject(e);
            });
        });
    }

    getFilters(): CrudQueryPredicate[] {

        let filters: CrudQueryPredicate[] = [{
            field: "billingId",
            op: "eq",
            comparand: this.billingId
        }];
        
        if (this.filterStart) 
            filters.push({ field: "workTask.time", op: "gte", comparand: moment(this.filterStart).format("YYYY-MM-DDT00:00:00") });
        
        if (this.filterEnd) 
            filters.push({ field: "workTask.time", op: "lte", comparand: moment(this.filterEnd).format("YYYY-MM-DDT23:59:59") });
        
        if (this.filterUser) 
            filters.push({ field: "userId", op: "eq", comparand: this.filterUser });
        
        if (this.filterType) 
            filters.push({ field: "workTask.catalogueItem.billingType", op: "eq", comparand: this.filterType });
        
        return filters;

    }

    getPayload() {
        return createCrudQueryPayload<WorkTaskStatementModel>({ field: "WorkTask.Time", index: 1, order: "asc"}, this.getFilters());
    }

    exportClick () {
        this.exportDialog.open();
    }

    exportDownload () {
        workTaskStatementsStore.dispatch(CrudAction.Download, this.getPayload());
        this.subscribe(workTaskStatementsStore, CrudReponse.Download).then(() => {
            this.exportDialog.close();
        });
    }

    openStatement (item: WorkTaskStatementModel) {
        this.dialog.open(item.id!);
    }

	unlock() {
		const billing = cloneDeep(this.billing);
		billing.isLocked = false;
		billing.isSentToClient = false;
		billingsStore.dispatch(CrudAction.Update, { item: billing, key: this.billingId });
		this.unlocking = true;
		this.subscribe(billingsStore, CrudReponse.Update, this.billingId).then(() => {
			this.unlocking = false;
		}).catch(() => {
			this.unlocking = false;
		});
	}

	lock() {
		const billing = cloneDeep(this.billing);
		billing.isLocked = true;
		billingsStore.dispatch(CrudAction.Update, { item: billing, key: this.billingId });
		this.isLocking = true;
		this.subscribe(billingsStore, CrudReponse.Update, this.billingId).then(() => {
			this.isLocking = false;
		}).catch(() => {
			this.isLocking = false;
		});
	}

    deleteItem () {
        this.deleting = true;
        billingsStore.dispatch(CrudAction.Delete, { id: this.billingId });
        this.subscribe(billingsStore, CrudReponse.Delete).then((e: BillingModel) => {
            this.deleting = false;
            this.deleteDialog = false;
            this.$router.replace({ name: "Billings" });
        }).catch((e: any) => {
            this.deleting = false;
        });
    }

	loadPayments(): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			paymentsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<PaymentModel>(undefined, [
				{ field: "billingId", op: QueryOperator.Eq, comparand: this.billingId }
			]));
			this.subscribe(paymentsStore, CrudReponse.GetAll).then(() => {
				resolve("ok");
			}).catch((e) => {
				reject(e);
			})
		})
	}

	addPaymentClick() {
		this.paymentDialog = true;
		this.activePayment = {
			id: Guid.EmptyGuid(),
			billingId: this.billingId,
			partyId: this.billing.partyId,
			paidOn: moment().format("YYYY-MM-DDT00:00:00"),
			paymentMethodId: undefined,
			paidAmount: undefined
		};
	}

	editPaymentClick(item: PaymentModel) {
		this.paymentDialog = true;
		this.activePayment = {...item};
	}

	savePayment() {
		if (this.activePayment!.id == Guid.EmptyGuid()) {
			paymentsStore.dispatch(CrudAction.Create, { item: this.activePayment })
			this.subscribe(paymentsStore, CrudReponse.Create).then(() => {
				this.loadPayments();
				this.loadBilling();
				this.paymentDialog = false;
			})
		}
		else {
			paymentsStore.dispatch(CrudAction.Update, { item: this.activePayment })
			this.subscribe(paymentsStore, CrudReponse.Update).then(() => {
				this.loadPayments();
				this.loadBilling();
				this.paymentDialog = false;
			})
		}
	}

	deletePaymentClick(item: PaymentModel) {
		this.deletePaymentDialog = true;
		this.activePayment = item;
	}

	deletePayment() {
		this.deletingPayment = true;
		paymentsStore.dispatch(CrudAction.Delete, { id: this.activePayment!.id });
		this.subscribe(paymentsStore, CrudReponse.Delete).then(() => {
			this.deletingPayment = false;
			this.deletePaymentDialog = false;
			this.loadPayments();
			this.loadBilling();
		}).catch(() => {
			this.deletingPayment = false;
		})
	}

	getBillingIsSending() {
		const billing = billingsStore.useGetter(CrudGetter.Detail, this.billingId) as BillingModel;
		return billing.transactionEmails!.any(x => x.type == TransactionEmailType.Billing && x.isSent == false);
	}

	getReceiptIsSending() {
		const billing = billingsStore.useGetter(CrudGetter.Detail, this.billingId) as BillingModel;
		return billing.transactionEmails!.any(x => x.type == TransactionEmailType.Receipt && x.isSent == false);
	}

	makeBillingAction(action: BillingActionEnum) {
		if (action == BillingActionEnum.SendBilling) {
			this.isSendingBillingToClient = true;
		}
		else if (action == BillingActionEnum.SendReceipt) {
			this.isSendingReceiptToClient = true;
		}
		const documentList: PatchBatchDocument[] = [
			{
				id: Guid.EmptyGuid(),
				query: [
					{ field: "id", op: QueryOperator.Eq, comparand: this.billingId! }
				],
				operations: []
			}
		];
		ApiService.api.patchBatchBilling(documentList, {
			headers: {
				"Action": action
			}
		}).then((req: any) => {
			if (action == BillingActionEnum.SendBilling) {
				this.isSendingBillingToClient = false;
			}
			else if (action == BillingActionEnum.SendReceipt) {
				this.isSendingReceiptToClient = false;
			}
			this.load();
		});
	}

}
